import dayjs from "dayjs";
import { EntryLogTable } from "features/log/components/table/entry-log";
import { EntryLogFilterFormValues, EntryLogFilterFormValuesPaginated, VehicleFilterFormValuesPaginated } from "features/log/components/Top-bar/type";
import { VehicleTopBar } from "features/log/components/Top-bar/vehicle-top-bar";
import { useGetLogList } from "features/log/use-cases/get-getSuppliers";
import { usePaginationParams } from "hooks";
import { omit } from "lodash";
import { useState } from "react";
import { formatDate } from "utils/date";
export const LogView = () => {
  const getInitialFilterValues: EntryLogFilterFormValues = {
    date: [undefined, undefined],
    DriverName: undefined,
    SupplierName: undefined,
    VehicleNumber: undefined,
    EntryTypeId: undefined,
    StatusId: undefined,
    date1: [undefined, undefined],

  };
  const [userEditData, setUserEditData] = useState<any>(undefined);
  const [showAppUserModal, setShowAppUserModal] = useState(false);
  const { params, updateParams, resetPage } =
    usePaginationParams<EntryLogFilterFormValuesPaginated>({
      page: 1,
      size: 10,
      ...getInitialFilterValues,
    });
  const preparePayload = (params1: EntryLogFilterFormValuesPaginated) => {
    const EntryStartDate = params1.date?.[0];
    const EntryEndDate = params1.date?.[1];
    const ExitStartDate = params1.date1?.[0];
    const ExitEndDate = params1.date1?.[1];

    return {
      ...omit(params1, ['date', 'date1']), // omit both ranges from direct spread
      EntryStartDate: EntryStartDate
        ? formatDate({
          date: dayjs(EntryStartDate),
          format: 'dbDate',
        })
        : undefined,
      EntryEndDate: EntryEndDate
        ? formatDate({
          date: dayjs(EntryEndDate).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
      ExitStartDate: ExitStartDate
        ? formatDate({
          date: dayjs(ExitStartDate).startOf('day'),
          format: 'dbDate',
        })
        : undefined,
      ExitEndDate: ExitEndDate
        ? formatDate({
          date: dayjs(ExitEndDate).endOf('day'),
          format: 'dbDate',
        })
        : undefined,
    };
  };


  const getvehcListQueryResponse: any = useGetLogList(preparePayload(params as any), {
    retry: false,
  });

  const handleFiltersChange = (values: VehicleFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
  };

  return (
    <>
      <VehicleTopBar
        getInitialFilterValues={getInitialFilterValues as any}
        handleFilter={handleFiltersChange}
        userEditData={userEditData}
        showAppUserModal={showAppUserModal}
        setShowAppUserModal={setShowAppUserModal}
        onRefresh={getvehcListQueryResponse.refetch}
      />
      <EntryLogTable
        isvehicleListLoading={
          getvehcListQueryResponse.isFetching
        }
        vehicleList={getvehcListQueryResponse?.data?.res?.items}
        itemsCount={getvehcListQueryResponse.data?.totalRecords || 0}
        tableParams={params as any}
        updateParams={updateParams}
        setUserEditData={setUserEditData}
        setShowAppUserModal={setShowAppUserModal}
         onRefresh={getvehcListQueryResponse.refetch}
        isFetching={ getvehcListQueryResponse.isFetching}

      />
    </>


  );
};
